// frontend/src/utils/vendorOffers.js
import { vendorPricesApi, vendorsApi } from './api';

// Fetch cached offers for a set of stem names across all CONNECTED vendors for a
// single date window [date, date+1). Triggers a background fetch for cold stems,
// then reads whatever is cached. `date` is an ISO yyyy-mm-dd string; when null,
// uses a near-term week window. Returns the raw offer rows (may be empty).
export async function fetchOffersForStems({ stems, date }) {
  const fmtIso = (d) => d.toISOString().slice(0, 10);
  const window = date
    ? { start: date, end: fmtIso(new Date(Date.parse(`${date}T00:00:00Z`) + 86400000)) }
    : (() => {
        const today = new Date();
        return { start: fmtIso(today), end: fmtIso(new Date(today.getTime() + 7 * 86400000)) };
      })();

  const enabled = ((await vendorsApi.list())?.data || []).filter(
    (v) => v.connection_status === 'connected',
  );
  if (!enabled.length || !stems.length) return [];

  await Promise.all(
    enabled.map((v) =>
      vendorPricesApi
        .fetch({ vendor_id: v.id, stems, date_start: window.start, date_end: window.end })
        .catch(() => null),
    ),
  );
  return (
    (
      await vendorPricesApi.offers({
        vendorIds: enabled.map((v) => v.id),
        stems,
        dateStart: window.start,
        dateEnd: window.end,
      })
    )?.data || []
  );
}

// Reduce offer rows to the cheapest offer per stem_key.
// Returns a Map<stem_key, offer>.
export function cheapestByStem(offers) {
  const map = new Map();
  for (const o of offers || []) {
    const key = o.stem_key;
    const price = Number(o.price_per_stem);
    if (!key || !(price > 0)) continue;
    const cur = map.get(key);
    if (!cur || price < Number(cur.price_per_stem)) map.set(key, o);
  }
  return map;
}
